import React from "react";
import { Wheel } from "react-custom-roulette";
import styles from "./styles.module.scss";
import { useRouletteStorage } from "src/services/rouletteAdapter";
import { useAwardsStorage } from "src/services/awardsAdapter";
import { useUserStorage } from "src/services/userAdapter";

const Roulette: React.FC = () => {
  const { isSpinning, winner, setSpin, rouletteEvent } = useRouletteStorage();
  const { awards, updateAward } = useAwardsStorage();
  const { user } = useUserStorage();

  const getReward = async () => {
    setSpin(false);
    updateAward(awards[winner]);
    if (rouletteEvent) {
      rouletteEvent.source.postMessage(awards[winner], rouletteEvent.origin);
    }
  };

  return (
    <div className={styles.roulette}>
      <Wheel
        mustStartSpinning={isSpinning}
        prizeNumber={winner}
        data={awards}
        textColors={["#fff"]}
        outerBorderColor="#B24C12"
        innerBorderColor="white"
        radiusLineColor="white"
        outerBorderWidth={30}
        innerBorderWidth={4}
        radiusLineWidth={2}
        textDistance={58}
        fontSize={user?.type === "3" ? 22 : 13}
        innerRadius={12}
        onStopSpinning={() => {
          getReward();
        }}
      />
    </div>
  );
};

export { Roulette };
